 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-19248fbe":"efb2643b","chunk-00783f87":"b27a3d93","chunk-0f676814":"6211e601","chunk-18ba78e7":"6485318c","chunk-1909e735":"4e86ffa5","chunk-30249248":"50889288","chunk-3cb5ae48":"249a1e05","chunk-49d50764":"564ac20c","chunk-4cdb03bb":"e6eb4d4c","chunk-5993639e":"e74d5c24","chunk-77e302e7":"78e9f218","chunk-d7786b8a":"5615b756","chunk-e7a01c1c":"2e047542","chunk-2517f78f":"d0d9af3c","chunk-17dd09c6":"f4d41038","chunk-1972011a":"8eb2e9ef","chunk-47e8d272":"f83365c8","chunk-5654f3ac":"a62e67ec","chunk-724cfef1":"40cb92cf","chunk-7f5200b5":"8424f4e5","chunk-8be1aa4a":"1d763252","chunk-8d20fc6c":"53e27cf5","chunk-b167fd9a":"071d3dac","chunk-dcab261e":"42b658c3","chunk-47683c48":"c650db47","chunk-18536b19":"5d428f37","chunk-21995cbc":"d06e01bc","chunk-2cf326e7":"25760ec6","chunk-3071c260":"86c48634","chunk-39fba004":"932c31e4","chunk-58484858":"a4251305","chunk-93b534c4":"37a082a8","chunk-a7c86504":"48874f21","chunk-df237ac6":"c2a1ea45","chunk-ee483ecc":"8bec2890","chunk-683cd50c":"a79ead97","chunk-0d70d34d":"d51c967c","chunk-351e19c8":"4804a59a","chunk-5b2d1dd4":"2a3152ef","chunk-5d4218b1":"9254b119","chunk-620a0498":"a05a2300","chunk-6a1ef6cf":"1c5d2dc6","chunk-76f7e504":"19c6c3e3","chunk-83c3f6e4":"1737fc2e","chunk-84635ff8":"163582aa","chunk-ed22d372":"583b9bd1","chunk-fd7a2114":"03b16437","chunk-83da9f06":"e5bf4750","chunk-2365985e":"8f8a4c16","chunk-2942df98":"6771a626","chunk-33758f26":"df1656e3","chunk-39800edf":"3ade589d","chunk-63b44a00":"d5fb697c","chunk-65904ba1":"15fcecaf","chunk-672bf9e9":"4ce0e936","chunk-695f34ef":"46bdea81","chunk-8cda3164":"06d2aedf","chunk-c541b06a":"7c5a2cc4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-19248fbe":1,"chunk-00783f87":1,"chunk-0f676814":1,"chunk-18ba78e7":1,"chunk-1909e735":1,"chunk-30249248":1,"chunk-3cb5ae48":1,"chunk-49d50764":1,"chunk-4cdb03bb":1,"chunk-5993639e":1,"chunk-77e302e7":1,"chunk-d7786b8a":1,"chunk-e7a01c1c":1,"chunk-2517f78f":1,"chunk-17dd09c6":1,"chunk-1972011a":1,"chunk-47e8d272":1,"chunk-5654f3ac":1,"chunk-724cfef1":1,"chunk-7f5200b5":1,"chunk-8be1aa4a":1,"chunk-8d20fc6c":1,"chunk-b167fd9a":1,"chunk-dcab261e":1,"chunk-47683c48":1,"chunk-18536b19":1,"chunk-21995cbc":1,"chunk-2cf326e7":1,"chunk-3071c260":1,"chunk-39fba004":1,"chunk-58484858":1,"chunk-93b534c4":1,"chunk-a7c86504":1,"chunk-df237ac6":1,"chunk-ee483ecc":1,"chunk-683cd50c":1,"chunk-0d70d34d":1,"chunk-351e19c8":1,"chunk-5b2d1dd4":1,"chunk-5d4218b1":1,"chunk-620a0498":1,"chunk-6a1ef6cf":1,"chunk-76f7e504":1,"chunk-83c3f6e4":1,"chunk-84635ff8":1,"chunk-ed22d372":1,"chunk-fd7a2114":1,"chunk-83da9f06":1,"chunk-2365985e":1,"chunk-2942df98":1,"chunk-33758f26":1,"chunk-39800edf":1,"chunk-63b44a00":1,"chunk-65904ba1":1,"chunk-672bf9e9":1,"chunk-695f34ef":1,"chunk-8cda3164":1,"chunk-c541b06a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-19248fbe":"c862c815","chunk-00783f87":"f4350ec0","chunk-0f676814":"f98dc868","chunk-18ba78e7":"d6f0a24e","chunk-1909e735":"33fd80d1","chunk-30249248":"6aa7b4fe","chunk-3cb5ae48":"6a5315f5","chunk-49d50764":"926880a7","chunk-4cdb03bb":"20fa1c55","chunk-5993639e":"7e99fa28","chunk-77e302e7":"168d8543","chunk-d7786b8a":"a8f9dddd","chunk-e7a01c1c":"5b8f22ff","chunk-2517f78f":"c862c815","chunk-17dd09c6":"2b576291","chunk-1972011a":"6e48aabb","chunk-47e8d272":"9a372d6b","chunk-5654f3ac":"2d70005a","chunk-724cfef1":"9f85ffbe","chunk-7f5200b5":"082c3fa6","chunk-8be1aa4a":"dfcd0b22","chunk-8d20fc6c":"455505e0","chunk-b167fd9a":"f6fd3f1d","chunk-dcab261e":"ce2d5073","chunk-47683c48":"c862c815","chunk-18536b19":"e4c74186","chunk-21995cbc":"7ce644cd","chunk-2cf326e7":"8a8db783","chunk-3071c260":"128d4bf4","chunk-39fba004":"a503fc91","chunk-58484858":"43caf030","chunk-93b534c4":"6fac5018","chunk-a7c86504":"2240fc47","chunk-df237ac6":"450966ed","chunk-ee483ecc":"10c0ba06","chunk-683cd50c":"c862c815","chunk-0d70d34d":"73224688","chunk-351e19c8":"5873652b","chunk-5b2d1dd4":"09ff2138","chunk-5d4218b1":"5a5e355d","chunk-620a0498":"716e129c","chunk-6a1ef6cf":"e6bf66ee","chunk-76f7e504":"9621336e","chunk-83c3f6e4":"7b16e8e3","chunk-84635ff8":"e8be96d6","chunk-ed22d372":"169362f0","chunk-fd7a2114":"96ba3bfb","chunk-83da9f06":"c862c815","chunk-2365985e":"0655b1d5","chunk-2942df98":"55acb051","chunk-33758f26":"5ccf02a4","chunk-39800edf":"018c592c","chunk-63b44a00":"2e878fbf","chunk-65904ba1":"acd938e5","chunk-672bf9e9":"5f3c14fe","chunk-695f34ef":"81a5c195","chunk-8cda3164":"778bc5e6","chunk-c541b06a":"cae41d15"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static001.geekbang.org/tgo/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
